import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { useContext, useEffect } from 'react';
import FocusGroupContext from './FocusGroupContext.js';

function useFocusGroupItem() {
  var ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var props = arguments.length > 1 ? arguments[1] : undefined;

  var _ref = useContext(FocusGroupContext) || {},
      register = _ref.register,
      unregister = _ref.unregister,
      otherActions = _objectWithoutProperties(_ref, ["register", "unregister"]);

  useEffect(function () {
    if (ref.current && register) register(ref.current, props);
    return function () {
      if (ref.current && unregister) unregister(ref.current);
    };
  }); // if the focus item is not wrapped with the focus provider then return null

  if (!register) return {};
  return otherActions;
}
var useFocusGroupWithState = function useFocusGroupWithState() {
  var ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var props = arguments.length > 1 ? arguments[1] : undefined;

  var _ref2 = useContext(FocusGroupContext) || {},
      register = _ref2.register,
      unregister = _ref2.unregister,
      otherActions = _objectWithoutProperties(_ref2, ["register", "unregister"]);

  useEffect(function () {
    if (ref && register) register(ref, props);
    return function () {
      if (ref && unregister) unregister(ref);
    };
  }, [ref]); // if the focus item is not wrapped with the focus provider then return null

  if (!register) return {};
  return otherActions;
};

export default useFocusGroupItem;
export { useFocusGroupWithState };
//# sourceMappingURL=useFocusGroupItem.js.map
